import { normalizeBase64String } from '@thoughtspot/codec-util';
import { translate as t } from '@thoughtspot/i18n';
import { Horizontal, Vertical, } from '@thoughtspot/radiant-react/widgets/layout';
import { CellType } from '@thoughtspot/radiant-react/widgets/table/table-list-view/cell/cell-type-service';
import { Colors, Typography, } from '@thoughtspot/radiant-react/widgets/typography';
import { getAdminGroupGuid, getAllGroupGUID, getGuidsToSkip, getSuperUserGuid, isPrincipalImportExportEnabled, isRolesEnabled, isSaaSCluster, isScriptabilityEnabled, } from '@thoughtspot/session-service';
import _ from 'lodash';
import React from 'react';
import { downloadFileUtil } from "../../../utils/file-download.util";
import { MoreOptions } from '../more-options/more-options';
import { MODE } from '../util';
import styles from './groups.module.scss';
export const zipFileExt = '.zip';
export const appType = 'application/x-yaml';
export const tslFileExt = '.tml';
export const zipType = 'application/zip';
export const userGroup = 'USER_GROUP';
export const ON_CHANGE_DELAY = 300;
export const GROUP_NAME_MAX_LENGTH = 255;
export const GROUP_DISPLAY_NAME_MAX_LENGTH = 124;
export const GROUP_DESC_MAX_LENGTH = 124;
export var TranslationsKeys;
(function (TranslationsKeys) {
    TranslationsKeys["SAVE"] = "Save";
    TranslationsKeys["CANCEL"] = "Cancel";
    TranslationsKeys["BACK"] = "Back";
    TranslationsKeys["LOADING"] = "LOADING_MSG";
    TranslationsKeys["WARNING"] = "WARNING";
    TranslationsKeys["DELETE"] = "DELETE";
    TranslationsKeys["MODAL_OK"] = "modal.ok";
    TranslationsKeys["PAGE_TITLE"] = "metadataListPage.groups.title";
    TranslationsKeys["COL_HEADER_GROUP_NAME"] = "groups.colHeader.groupName";
    TranslationsKeys["GROUP_NAME"] = "adminUI.captions.GROUP_NAME";
    TranslationsKeys["ADD_GROUP_BUTTON_TITLE"] = "groups.createModal.title";
    TranslationsKeys["DISPLAY_NAME"] = "adminUI.captions.DISPLAYED_NAME";
    TranslationsKeys["DESCRIPTION"] = "adminUI.captions.DESCRIPTION";
    TranslationsKeys["CREATED"] = "metadataListPage.captions.CREATED";
    TranslationsKeys["MEMBER_USERS"] = "adminUI.captions.USER_LABEL";
    TranslationsKeys["CREATE_MODAL_TITLE"] = "groups.createModal.title";
    TranslationsKeys["EDIT_MODAL_TITLE"] = "groups.editModal.title";
    TranslationsKeys["TAB_DESCRIBE_GROUP"] = "groups.modalTabLinkLabel.describeGroup";
    TranslationsKeys["TAB_SELECT_ROLES"] = "groups.modalTabLinkLabel.selectRoles";
    TranslationsKeys["TAB_SELECT_CHILD_GROUPS"] = "groups.modalTabLinkLabel.selectChildGroup";
    TranslationsKeys["TAB_SELECT_USERS"] = "groups.modalTabLinkLabel.selectUsers";
    TranslationsKeys["TAB_SELECT_MANAGE_LIVEBOARDS"] = "groups.modalTabLinkLabel.manageLiveboardsTab";
    TranslationsKeys["TAB_SELECT_DEFAULT_LIVEBOARDS"] = "groups.modalTabLinkLabel.selectDefaultLiveboards";
    TranslationsKeys["NEW_DEFAULT_LIVEBOARD_INTRODUCTION_1"] = "adminUI.captions.DEFAULT_PINBOARD_INTRODUCTION_1";
    TranslationsKeys["ADMIN_DEFAULT_LIVEBOARD_INTRODUCTION_ERROR"] = "adminUI.captions.DEFAULT_PINBOARD_ADMIN_GROUP_ERROR_MESSAGE";
    TranslationsKeys["DEFAULT_LIVEBOARD_MESSAGE"] = "adminUI.captions.DEFAULT_PINBOARD_MESSAGE";
    TranslationsKeys["FIELDS_GROUP_NAME_DESC"] = "groups.modalFieldsLabel.groupNameAndDescription";
    TranslationsKeys["FIELDS_ALLOW_OTHERS_TO_SHARE"] = "groups.modalFieldsLabel.allowOthersToShare";
    TranslationsKeys["REVIEW_SELECTION"] = "roles.modal.reviewSelection";
    TranslationsKeys["ADD_SUCCESS_MSG"] = "msg_code.1205.summary";
    TranslationsKeys["UPDATE_SUCCESS_MSG"] = "msg_code.1211.summary";
    TranslationsKeys["DELETE_SUCCESS_MSG"] = "msg_code.1217.summary";
    TranslationsKeys["DISPLAY_NAME_REQUIRED"] = "groups.modalFieldsLabel.formFieldsRequired.fieldDisplayName";
    TranslationsKeys["NAME_REQUIRED"] = "groups.modalFieldsLabel.formFieldsRequired.fieldName";
    TranslationsKeys["MODAL_FORM_NAME_MAX_LIMIT"] = "roles.modal.formFields.validName.maxLimit";
    TranslationsKeys["MODAL_FORM_FIELD_CHAR_LIMIT"] = "groups.modal.formFields.validField.charLimit";
    TranslationsKeys["MODAL_FORM_DESC_MAX_LIMIT"] = "roles.modal.formFields.validDescription.maxLimit";
    TranslationsKeys["CLEAR"] = "Clear";
    TranslationsKeys["SELECT_ALL"] = "smartCheckboxCollection.SELECT_ALL_ITEMS";
    TranslationsKeys["SHOW_SELECTED"] = "autoWorksheet.selectedItemsToggle.SHOW_SELECTED";
    TranslationsKeys["SHARING"] = "groups.modalFieldsLabel.reviewScreen.sharing";
    TranslationsKeys["CHILD_GROUP"] = "groups.modalFieldsLabel.reviewScreen.childGroup";
    TranslationsKeys["CHILD_GROUPS"] = "groups.modalFieldsLabel.groupScreen.childGroups";
    TranslationsKeys["ROLES_TITLE"] = "roles.pageTitle";
    TranslationsKeys["COL_HEADER_MORE_OPTIONS"] = "roles.colHeader.moreOptions";
    TranslationsKeys["MORE_OPTIONS_EDIT"] = "EDIT";
    TranslationsKeys["MORE_OPTIONS_DELETE"] = "DELETE";
    TranslationsKeys["CONFIRM_DELETE"] = "CONFIRM_DELETE";
    TranslationsKeys["DELETE_BODY"] = "alert.GROUP_DELETE_DIALOG_MESSAGE_SINGULAR";
    TranslationsKeys["DELETE_BODY_PLURAL"] = "alert.GROUP_DELETE_DIALOG_MESSAGE_PLURAL";
    TranslationsKeys["ADMIN_RLS_WARNING"] = "ADMIN_RLS_WARNING";
    TranslationsKeys["PRIVILEGES_LABEL"] = "groups.modalTabLinkLabel.selectPrivileges";
    TranslationsKeys["EXPORT"] = "EXPORT";
    TranslationsKeys["IMPORT_GROUP_TITLE"] = "groups.list.importGroupTitle";
    TranslationsKeys["SEND_MESSAGE_PLACEHOLDER"] = "adminUI.captions.SEND_MESSAGE_PLACEHOLDER";
    TranslationsKeys["SEND"] = "Send";
    TranslationsKeys["EMAIL_RESEND_CONFIRMATION"] = "adminUI.captions.EMAIL_RESEND_CONFIRMATION";
    TranslationsKeys["TEST_WELCOME_EMAIL"] = "adminUI.captions.WELCOME_EMAIL";
    TranslationsKeys["ADMIN_EMAIL_SENT_CONFIRMATION"] = "adminUI.captions.ADMIN_EMAIL_SENT_CONFIRMATION";
    TranslationsKeys["RESEND_WELCOME_EMAIL_EXPLAINER"] = "adminUI.captions.RESEND_WELCOME_EMAIL_EXPLAINER";
    TranslationsKeys["ALL_USERS"] = "adminUI.captions.ALL_USERS";
    TranslationsKeys["NEW_USERS"] = "adminUI.captions.NEW_USERS";
    TranslationsKeys["VIEW_ALL_PRIVILEGES"] = "groups.view_privileges.label";
    TranslationsKeys["ALL_PRIVILEGES"] = "groups.view_privileges.title";
    TranslationsKeys["DONE"] = "DONE";
    TranslationsKeys["NO_ROLES_SELECTED"] = "groups.view_privileges.noRoles";
    TranslationsKeys["ALL_ROLES_PRIVILEGES"] = "groups.all_roles_privileges.title";
    TranslationsKeys["VIEW_ALL_ROLES_PRIVILEGES"] = "groups.view_all_roles_privileges.label";
    TranslationsKeys["NO_PRIVILEGE_ASSIGNED"] = "groups.view_all_roles_privileges.no_privilege";
    TranslationsKeys["EXPORT_LIMIT_ERROR"] = "principal.export.error.maxLimit";
    TranslationsKeys["ADMINISTRATION"] = "ADMINISTRATION";
})(TranslationsKeys || (TranslationsKeys = {}));
export var ListActionType;
(function (ListActionType) {
    ListActionType["EDIT"] = "edit";
    ListActionType["DELETE"] = "delete";
    ListActionType["EXPORT"] = "export";
    ListActionType["VIEW_ALL_PRIVILEGES"] = "view_all_privileges";
})(ListActionType || (ListActionType = {}));
export var SendEmailUser;
(function (SendEmailUser) {
    SendEmailUser["ALL_USERS"] = "ALL_USERS";
    SendEmailUser["NEW_USERS"] = "NEW_USERS";
})(SendEmailUser || (SendEmailUser = {}));
export var tableColumnHeaders;
(function (tableColumnHeaders) {
    tableColumnHeaders["GROUP_NAME"] = "groupName";
    tableColumnHeaders["GROUP_DISPLAY_NAME"] = "groupDisplayName";
    tableColumnHeaders["GROUP_CREATED"] = "groupCreated";
    tableColumnHeaders["MEMBER_USERS"] = "memberUsers";
    tableColumnHeaders["DESCRIPTION"] = "description";
    tableColumnHeaders["MORE_OPTION"] = "moreOption";
})(tableColumnHeaders || (tableColumnHeaders = {}));
export var GROUP_TABS;
(function (GROUP_TABS) {
    GROUP_TABS["ROLES"] = "ROLES";
    GROUP_TABS["PRIVILEGES"] = "PRIVILEGES";
    GROUP_TABS["LIVEBOARDS"] = "LIVEBOARDS";
    GROUP_TABS["GROUPS"] = "GROUPS";
    GROUP_TABS["USERS"] = "USERS";
    GROUP_TABS["DESCRIPTION"] = "DESCRIPTION";
})(GROUP_TABS || (GROUP_TABS = {}));
export const sortKeyMap = {
    [tableColumnHeaders.GROUP_DISPLAY_NAME]: 'DISPLAY_NAME',
    [tableColumnHeaders.GROUP_NAME]: 'NAME',
    [tableColumnHeaders.GROUP_CREATED]: 'CREATED',
};
export const generateMoreOption = (context, data) => {
    const editOption = {
        title: 'Group1',
        items: [
            {
                id: ListActionType.EDIT,
                label: t(TranslationsKeys.MORE_OPTIONS_EDIT),
                onClick: () => {
                    context.onRowAction({
                        action: ListActionType.EDIT,
                        data,
                    });
                },
            },
        ],
    };
    const deleteOption = {
        title: 'Group2',
        items: [
            {
                id: ListActionType.DELETE,
                label: t(TranslationsKeys.MORE_OPTIONS_DELETE),
                onClick: () => {
                    context.onRowAction({
                        action: ListActionType.DELETE,
                        data,
                    });
                },
                itemDisabled: data.id === getAdminGroupGuid(),
            },
        ],
    };
    const exportOption = {
        title: 'Group3',
        items: [
            {
                id: ListActionType.EXPORT,
                label: t(TranslationsKeys.EXPORT),
                onClick: () => {
                    context.onRowAction({
                        action: ListActionType.EXPORT,
                        data,
                    });
                },
            },
        ],
    };
    const viewPrivilegesOption = {
        title: 'Group4',
        items: [
            {
                id: ListActionType.VIEW_ALL_PRIVILEGES,
                label: t(TranslationsKeys.VIEW_ALL_PRIVILEGES),
                onClick: () => {
                    context.onRowAction({
                        action: ListActionType.VIEW_ALL_PRIVILEGES,
                        data,
                    });
                },
            },
        ],
    };
    const isPrincipalTmlEnabled = isPrincipalImportExportEnabled() && isScriptabilityEnabled();
    if (isRolesEnabled()) {
        if (isPrincipalTmlEnabled) {
            return [
                viewPrivilegesOption,
                editOption,
                exportOption,
                deleteOption,
            ];
        }
        return [viewPrivilegesOption, editOption, deleteOption];
    }
    if (isPrincipalTmlEnabled) {
        return [editOption, exportOption, deleteOption];
    }
    return [editOption, deleteOption];
};
const GroupDisplayNameEle = ({ groupDisplayName, }) => {
    return (React.createElement(Vertical, null,
        React.createElement(Horizontal, { className: styles.groupDisplayName },
            React.createElement(Typography, { variant: "p", overrideTag: "div", color: Colors.base, ellipsis: { rows: 1 }, tooltipConfig: {
                    showTooltipOnlyOnEllipsis: true,
                    dataTooltipAlign: 'center',
                    dataTooltipContent: groupDisplayName,
                } }, groupDisplayName))));
};
const GroupDescriptionEle = ({ groupName }) => {
    return (React.createElement(Vertical, null,
        React.createElement(Horizontal, { className: styles.groupDescription },
            React.createElement(Typography, { variant: "p", overrideTag: "div", color: Colors.base, ellipsis: { rows: 1 }, tooltipConfig: {
                    showTooltipOnlyOnEllipsis: true,
                    dataTooltipAlign: 'center',
                    dataTooltipContent: groupName,
                } }, groupName))));
};
export const GroupNameEle = ({ data, context }) => {
    const name = data[tableColumnHeaders.GROUP_NAME].text;
    const elementProps = {
        variant: 'p',
        overrideTag: 'div',
        children: name,
        ellipsis: { rows: 1 },
        tooltipConfig: {
            showTooltipOnlyOnEllipsis: true,
            dataTooltipAlign: 'center',
            dataTooltipContent: name,
        },
    };
    if (!data.readOnly) {
        elementProps.color = Colors.accent;
        elementProps.className = styles.groupName;
        elementProps.onClick = () => {
            context.onRowAction({
                action: ListActionType.EDIT,
                data,
            });
        };
    }
    return (React.createElement("div", { className: styles.groupNameWrapper },
        React.createElement(Vertical, null,
            React.createElement(Typography, { ...elementProps }))));
};
export const DEFAULT_PAGINATION_BATCHSIZE = 20;
export const getColumnDefinitions = () => {
    return [
        {
            cellRendererFramework: (params) => {
                return React.createElement(GroupNameEle, { ...params });
            },
            headerName: t(TranslationsKeys.COL_HEADER_GROUP_NAME),
            headerClass: [styles.headerStyle],
            colId: tableColumnHeaders.GROUP_NAME,
            suppressMovable: true,
            sortable: true,
            initialSort: 'asc',
            flex: 2,
        },
        {
            cellRendererFramework: (params) => {
                const { groupDisplayName } = params.data;
                return (React.createElement(GroupDisplayNameEle, { groupDisplayName: groupDisplayName.text }));
            },
            headerName: t(TranslationsKeys.DISPLAY_NAME),
            headerClass: [styles.headerStyle],
            colId: tableColumnHeaders.GROUP_DISPLAY_NAME,
            suppressMovable: true,
            flex: 2,
        },
        {
            cellRendererFramework: (params) => {
                const { description } = params.data;
                return React.createElement(GroupDescriptionEle, { groupName: description.text });
            },
            headerName: t(TranslationsKeys.DESCRIPTION),
            headerClass: [styles.headerStyle],
            colId: tableColumnHeaders.DESCRIPTION,
            sortable: false,
            suppressMovable: true,
            flex: 2,
        },
        {
            cellRenderer: CellType[CellType.text],
            headerName: t(TranslationsKeys.MEMBER_USERS),
            headerClass: [styles.headerStyle],
            colId: tableColumnHeaders.MEMBER_USERS,
            suppressMovable: true,
            sortable: false,
            flex: 1,
        },
        {
            cellRenderer: CellType[CellType.text],
            headerName: t(TranslationsKeys.CREATED),
            headerClass: [styles.headerStyle],
            colId: tableColumnHeaders.GROUP_CREATED,
            suppressMovable: true,
            sortable: true,
            flex: 1,
        },
        {
            cellRenderer: (params) => {
                const { context, data } = params;
                if (data.readOnly) {
                    return null;
                }
                return (React.createElement(MoreOptions, { menuId: 1, menuLabel: t(TranslationsKeys.COL_HEADER_MORE_OPTIONS), menuItemGroups: generateMoreOption(context, data), isDisabled: data.isChecked }));
            },
            colId: tableColumnHeaders.MORE_OPTION,
            headerName: '',
            headerClass: [styles.headerStyle, styles.moreHeaderStyle],
            sortable: false,
            width: 50,
            suppressMovable: true,
        },
    ];
};
export const groupParams = {
    sort: 'NAME',
    sortAscending: true,
    batchSize: DEFAULT_PAGINATION_BATCHSIZE,
    offset: 0,
    pattern: '',
    category: 'ALL',
    skipIds: getGuidsToSkip(),
};
const getRolesOrPrivileges = (isRolesEnabled = false) => {
    if (isRolesEnabled) {
        return 'selectRoles';
    }
    return 'selectPrivileges';
};
export const TAB_LABEL_ID = {
    DESCRIBE_GROUP: 'describeGroup',
    SELECT_PRIVILEGES: 'selectPrivileges',
    MANAGE_LIVEBOARD_TAB: 'manageLiveboardsTab',
    SELECT_ROLES: 'selectRoles',
    SELECT_CHILD_GROUPS: 'selectChildGroups',
    SELECT_USERS: 'selectUsers',
    RESEND_WELCOME_EMAIL: 'resendWelcomeEmail',
};
export const createEditTabLinkLabels = (isRolesEnabled = false, isEditMode = false) => {
    const manageLiveboardTab = !isSaaSCluster() ? ['manageLiveboardsTab'] : [];
    if (isEditMode) {
        return [
            'describeGroup',
            getRolesOrPrivileges(isRolesEnabled),
            ...manageLiveboardTab,
            'selectChildGroup',
            'selectUsers',
            'resendWelcomeEmail',
        ];
    }
    return [
        'describeGroup',
        getRolesOrPrivileges(isRolesEnabled),
        ...manageLiveboardTab,
        'selectChildGroup',
        'selectUsers',
    ];
};
export const hasCreateEditInputError = (hasInputError, form, untouchedFields) => {
    const { description, displayName, name } = form;
    let isNameRequired = false;
    let isNameLong = false;
    let isDisplayNameRequired = false;
    let isDisplayNameLong = false;
    let isDescriptionLong = false;
    if (!untouchedFields.isNameUntouched && _.isEmpty(name)) {
        isNameRequired = true;
    }
    if (!untouchedFields.isDisplayNameUntouched && _.isEmpty(displayName)) {
        isDisplayNameRequired = true;
    }
    if (name.length > GROUP_NAME_MAX_LENGTH) {
        isNameLong = true;
    }
    if (displayName.length > GROUP_DISPLAY_NAME_MAX_LENGTH) {
        isDisplayNameLong = true;
    }
    if (description.length > GROUP_DESC_MAX_LENGTH) {
        isDescriptionLong = true;
    }
    return {
        ...hasInputError,
        isDisplayNameRequired,
        isDisplayNameLong,
        isNameRequired,
        isNameLong,
        isDescriptionLong,
    };
};
export const getInputLabelColor = (hasError) => {
    const { isDisplayNameRequired, isDisplayNameLong, isNameRequired, isNameLong, isDescriptionLong, } = hasError;
    return (isDisplayNameRequired ||
        isDisplayNameLong ||
        isNameRequired ||
        isNameLong ||
        isDescriptionLong);
};
export const getInputLabel = (hasError, translate, isDisplayName = false) => {
    if (hasError.isDisplayNameRequired && isDisplayName) {
        return translate(TranslationsKeys.DISPLAY_NAME_REQUIRED);
    }
    if (hasError.isDisplayNameLong && isDisplayName) {
        return translate(TranslationsKeys.MODAL_FORM_FIELD_CHAR_LIMIT, {
            field_name: translate(TranslationsKeys.DISPLAY_NAME),
            char_limit: GROUP_DISPLAY_NAME_MAX_LENGTH,
        });
    }
    if (hasError.isNameRequired && !isDisplayName) {
        return translate(TranslationsKeys.NAME_REQUIRED);
    }
    if (hasError.isNameLong && !isDisplayName) {
        return translate(TranslationsKeys.MODAL_FORM_FIELD_CHAR_LIMIT, {
            field_name: translate(TranslationsKeys.GROUP_NAME),
            char_limit: GROUP_NAME_MAX_LENGTH,
        });
    }
    if (hasError.isDescriptionLong && !isDisplayName) {
        return translate(TranslationsKeys.MODAL_FORM_FIELD_CHAR_LIMIT, {
            field_name: translate(TranslationsKeys.DESCRIPTION),
            char_limit: GROUP_DESC_MAX_LENGTH,
        });
    }
    return isDisplayName
        ? translate(TranslationsKeys.DISPLAY_NAME)
        : translate(TranslationsKeys.FIELDS_GROUP_NAME_DESC);
};
export const getToastMessage = (scenario, groupsCount = 0) => {
    if (scenario === MODE.ADD) {
        return t(TranslationsKeys.ADD_SUCCESS_MSG);
    }
    if (scenario === MODE.UPDATE) {
        return t(TranslationsKeys.UPDATE_SUCCESS_MSG);
    }
    if (scenario === MODE.DELETE) {
        return t(TranslationsKeys.DELETE_SUCCESS_MSG);
    }
    return null;
};
export const transformToIdsFromListObject = (listIds, excludeIds) => {
    return listIds.reduce((acc, record) => {
        if (!excludeIds.includes(record.id)) {
            acc.push(record.id);
        }
        return acc;
    }, []);
};
export const roleListParams = {
    sortascending: true,
    batchsize: 200,
    offset: 0,
    pattern: '',
};
export const getGroupsForGroup = (groups) => {
    return groups
        .filter((item) => item.header.id !== getAllGroupGUID())
        .map(({ header: { displayName, id, name, orgIds, type } }) => ({
        displayName,
        id,
        name,
        numMemberUsers: 0,
        orgIds,
        type,
    }));
};
export const getUsersForGroup = (users) => {
    return users.filter((item) => item.id !== getSuperUserGuid());
};
const downloadFile = (epack, customFileName, containsMultipleObjects, shouldExportDependencies) => {
    const objects = epack.object;
    let type = '';
    let blobContent;
    let fileName = customFileName;
    if (containsMultipleObjects || shouldExportDependencies) {
        const normalized = normalizeBase64String(epack.zipFile);
        const buffer = new Uint8Array(Array.from(atob(normalized), (c) => c.charCodeAt(0)));
        blobContent = buffer;
        fileName += zipFileExt;
        type = zipType;
    }
    else {
        blobContent = objects[0].edoc;
        fileName += tslFileExt;
        type = appType;
    }
    downloadFileUtil({
        blob: new Blob([blobContent], { type }),
        fileName,
    });
};
export const downloadExportedGroups = (epack, shouldExportDependencies, customName) => {
    const objects = epack.object;
    const containsMultipleObjects = objects.length > 1;
    let fileName = '';
    if (containsMultipleObjects) {
        fileName = customName || userGroup;
    }
    else {
        const suffix = userGroup.toLocaleLowerCase();
        fileName = `${customName ||
            objects[0].name ||
            objects[0].id}.${suffix}`;
    }
    downloadFile(epack, fileName, containsMultipleObjects, shouldExportDependencies);
};
//# sourceMappingURL=util.js.map